<template>
  <CModal size="xl" :visible="showModal" @close="closeAddModal">
    <CModalHeader class="candidate-modal-body">
      <CModalTitle> {{ $t('pins.addPin') }} </CModalTitle>
    </CModalHeader>

    <CModalBody class="candidate-modal-body">
      <CForm class="form-wrapper">
        <div class="mb-3">
          <CFormLabel>{{ $t('pins.name') }}</CFormLabel>
          <CFormInput v-model="pinName" />
        </div>
        <div class="mb-3">
          <CFormLabel>{{ $t('pins.url') }}</CFormLabel>
          <CFormInput v-model="pinUrl" />
        </div>
      </CForm>
    </CModalBody>

    <CModalFooter class="candidate-modal-body footer-wrapper">
      <div class="div"></div>

      <div class="btns-wrapper">
        <CButton @click="closeAddModal" color="secondary" size="sm">
          {{ $t('general.close') }}
        </CButton>

        <CButton @click="addPin" color="primary" size="sm">
          {{ $t('pins.addPin') }}
        </CButton>
      </div>
    </CModalFooter>
  </CModal>
</template>

<script>
/* eslint-disable */ 
import { ref, watch, getCurrentInstance } from 'vue' 
import { useStore } from 'vuex'
import { useRoute } from 'vue-router'
import fireSwal from "@/helpers/fireSwal"

export default {
  name: 'AddPinModal',
  emits: ['closeAddModal', 'refreshPins'],
  props: {
    showModal: { type: Boolean, required: true }
  },
  setup(props, { emit }) {
    const { proxy } = getCurrentInstance() 
    const store = useStore()
    const route = useRoute()

    const pinName = ref('')
    const pinUrl = ref('')

    watch(() => props.showModal, (newVal) => {
      if (newVal) pinUrl.value = window.location.href
    })

    const closeAddModal = () => emit('closeAddModal')

    const addPin = () => {
      if (!pinName.value || !pinUrl.value) {
        fireSwal(proxy.$t('pins.allFieldsRequested'), 'error')
        return
      }

      store.dispatch('notifications/addPin', {
        name: pinName.value,
        url: pinUrl.value
      })
        .then(() => {
          fireSwal(proxy.$t('pins.pinAdded'), 'success')
          emit('refreshPins')
          closeAddModal()
        })
        .catch(console.error)
    }

    return { pinName, pinUrl, addPin, closeAddModal }
  }
}
</script>

<style scoped lang="scss">
.btns-wrapper {
  display: flex;
  gap: 20px;
}
</style>
